import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalFilterService  {

  public selectedFilter: GlobalFilterObj[] = [];
  public filterSubject = new Subject<any>();

  private disableLocationSubject = new Subject<boolean>();
  private disableDepartmentSubject = new Subject<boolean>();

  public locationFilterSubject = new Subject<GlobalFilterObj>();
  public departmentFilterSubject = new Subject<GlobalFilterObj>();

  constructor(
  ) {
    if(!this.selectedFilter.length) {
      let defaultUser;
      let role = localStorage.getItem('roleId');
      if(role == "1") {
        defaultUser = '[{"type": "location","name": "All"}]'
      }
      this.setGlobalFilter(JSON.parse(localStorage.getItem('globalFilter') || defaultUser || "{}")[0] )
    }
  }

  public setGlobalFilter(filter) {
    if(!filter) return;
    if(localStorage.getItem('globalFilter')) {
      this.selectedFilter = JSON.parse(localStorage.getItem('globalFilter'));
      this.selectedFilter = this.selectedFilter.filter(filterObj => {
        if(filterObj.type != filter.type) {
          return true;
        }
      });
      this.selectedFilter.push(filter);

    } else {
      this.selectedFilter.push(filter);
    }
    localStorage.setItem('globalFilter', JSON.stringify(this.selectedFilter));
    this.updateFilter(filter);
    this.filterSubject.next(this.selectedFilter);
  }

  getGlobalFilter(): Observable<GlobalFilterObj[]> {
    return this.filterSubject.asObservable();
  }

  public disableFilter(state, type?) {
    if(type == 'location') {
      this.disableLocationSubject.next(state);
    } else if(type == 'department') {
      this.disableDepartmentSubject.next(state);
    } else {
      this.disableLocationSubject.next(state);
      this.disableDepartmentSubject.next(state);
    }
  }

  public getLocationFilterState() {
    return this.disableLocationSubject.asObservable();
  }

  public getDepartmentFilterState() {
    return this.disableDepartmentSubject.asObservable();
  }

  public getFilterObj(type) {
    let filterObj;
    this.selectedFilter.map(filter =>  {
      if(filter.type == type) {
        filterObj = filter;
      }
    });
    return filterObj;
  }

  public updateFilter(filterObj) {
    if(filterObj.type == 'location') {
      this.locationFilterSubject.next(filterObj);
    } else if ( filterObj.type == 'department') {
      this.departmentFilterSubject.next(filterObj);
    }
  }

  public get locationFilter() {
    return this.locationFilterSubject.asObservable();
  }


  public get departmentFilter() {
    return this.departmentFilterSubject.asObservable();
  }

  public clearGlobalFilter() {
    this.selectedFilter = [];
    localStorage.removeItem('globalFilter');
    this.filterSubject.next(this.selectedFilter);
    this.disableLocationSubject.next(false);
    this.disableDepartmentSubject.next(false);
    //this.locationFilterSubject.next(null);
    this.departmentFilterSubject.next(null);
  }

}


export interface GlobalFilterObj {
  type: string,
  name: string,
  id?: number,
  ind_id?: number,
  bsa_form_type?: number,
  practice_name?: string
}

/** Default "All locations" selection. Spread it when assigning so each owner gets its own copy. */
export const ALL_LOCATIONS_FILTER: GlobalFilterObj = {
  type: 'location',
  name: 'All',
  id: -1,
  ind_id: -1,
  bsa_form_type: 1
};
